export default {
    // nome app
    "SalesPaddy":"SalesPaddy",
    // tabs
    "Home":"Home",
    "Salons":"Saloni",
    "Users":"Utenti",
    "Dealers":"Dealers",
    "Digital Inventory":"Digital Inventory",
    // filtro nelle tabelle
    "Applica filtro":"Applica filtro",
    "filtro...":"filtro...",
    // azioni salon
    "Crea":"Crea",
    // salons: tabella e form
    "Ragione Sociale":"Ragione Sociale",
    "Insegna":"Insegna",
    "Autocomplete":"Completamento automatico",
    "Indirizzo":"Indirizzo",
    "Città":"Città",
    "Cap":"Cap",
    "Paese":"Paese",
    "Provincia":"Provincia",
    "Nazione":"Nazione",
    "Email":"Email",
    "Telefono":"Telefono",
    "Web":"Web",
    "Attivo":"Attivo",
    "Alert":"Alert",
    "Tipo":"Tipo",
    "Latitude":"Latitude",
    "Longitude":"Longitude",
    "Latitude2":"Latitude2",
    "Longitude2":"Longitude2",
    // sezioni form
    "Dati principali":"Dati principali",
    "Sede Legale":"Sede Operativa",
    "Contatto":"Contatto",
    "Dati qualitativi":"Dati qualitativi",
    // users: tabella e form
    "Dealer":"Dealer",
    "Codice X3":"Codice X3",
    "Nome":"Nome",
    "Cognome":"Cognome",
    "Lingua":"Lingua",
    "Privilegi":"Privilegi",
    // sezioni form
    "Dati Anagrafici":"Dati Anagrafici",
    //
    "Codice Dealer":"Codice Dealer",
    "Inserire il codice":"Inserire il codice",
    "Codice Dealer non trovato":"Codice Dealer non trovato",
    // mappa
    "Mappa Saloni":"Mappa Saloni",
    "Saloni visualizzati:":"Saloni visualizzati:",
    "Leads":"Leads",
    "Saloni":"Saloni",
    "Tipo Visualizzazione:":"Tipo Visualizzazione:",
    "Heatmap":"Heatmap",
    "Markers":"Markers",
    "Scheda Lead":"Scheda Lead",
    "Scheda Cliente":"Scheda Cliente",
    "Google Maps":"Google Maps",
    "Risultato ricerca:":"Risultato ricerca:",
    "Corrispondenze trovate:":"Corrispondenze trovate:",
    "Valutazione:":"Valutazione:",
    "Recensioni:":"Recensioni:",
    "x":"x",
    // digital inventory
    "official_site__label":"is there an official country brand site?",
    "official_ecommerce__label":"is this site an ecommerce ?",
    "official_domain__label":"what is the domain* name?",
    "official_domain__tip":"*Web domains are the www address naming under which you can retrieve the website on the internet (URL).A web domain is composed of 2 parts: a naming suffix, a dot extension acronym ( e.g: davines.com)",
    "multibrand_website__label":"does your company / group directly own a multi-brand informative website which includes our products?",
    "multibrand_domain__label":"what is the domain* name?",
    "multibrand_ecommerce__label":"does your company / group directly own a multi-brand ecommerce which sells our products?",
    "multibrand_ecommerce_domain__label":"what is the domain* name?",
    "marketplaces__label":"do you directly sell to end users through some marketplaces*?",
    "marketplaces__tip":"An online marketplace is a website or mobile application that connects buyers and sellers (e.g: Ebay, Amazon)",
    "marketplaces_list__label":"please list all marketplaces:",
    "digitally_selling_branded__label":"do you directly or indirectly sell our products through other e-commerce websites in the country?",
    "relevant_ecommerce__label":"if yes, please list all relevant e-commerce websites:",
    "Domain":"Domain",
    "Owned by":"Owned by",
    "Third party":"Third party e-retailer",
    "Salon owned":"Salon/store owned",
    "WEBSITES":"WEBSITES",
    // domain again...
    "domains__label":"please list all domains associated with the brand in your country",
    "Your property":"Your property",
    "Davines property":"Davines property",
    "DOMAINS":"DOMAINS",
    "social__label":"please list all social media pages/ account/ groups associated with the brand in your country directly managed",
    "Social media":"Social media",
    "Link":"Link",
    "SOCIAL MEDIA":"SOCIAL MEDIA",

}